export default __webpack_public_path__ + "static/media/2_magic 1.94a531dd.png";